/**
 * Estado de filtros da aba Produtos do Dashboard.
 */

export const EMPTY_PRODUTOS_FILTER_STATE = {
  ids_categorias: [],
  ids_subcategorias: [],
  availability: "",
  search: "",
  labels: {
    categories: {},
    subcategories: {},
  },
};

function toPositiveIntArray(raw) {
  const list = Array.isArray(raw) ? raw : raw != null && raw !== "" ? String(raw).split(",") : [];
  const out = [];
  const seen = new Set();
  for (const item of list) {
    const n = Number(String(item ?? "").trim());
    if (!Number.isFinite(n) || n <= 0 || seen.has(n)) continue;
    seen.add(n);
    out.push(n);
  }
  return out;
}

function normalizeLabels(map) {
  if (!map || typeof map !== "object") return {};
  const out = {};
  for (const [k, v] of Object.entries(map)) {
    const id = String(k).trim();
    const label = String(v ?? "").trim();
    if (!id || !label) continue;
    out[id] = label;
  }
  return out;
}

export function normalizeProdutosFilterState(raw) {
  const s = raw && typeof raw === "object" ? raw : {};
  const labels = s.labels && typeof s.labels === "object" ? s.labels : {};
  const availability = String(s.availability || "").trim().toLowerCase();
  return {
    ids_categorias: toPositiveIntArray(s.ids_categorias),
    ids_subcategorias: toPositiveIntArray(s.ids_subcategorias),
    availability: availability === "imediata" || availability === "sob-encomenda" ? availability : "",
    search: String(s.search || "").trim(),
    labels: {
      categories: normalizeLabels(labels.categories),
      subcategories: normalizeLabels(labels.subcategories),
    },
  };
}

export function countProdutosFilterCriteria(state) {
  const s = normalizeProdutosFilterState(state);
  let n = 0;
  if (s.ids_categorias.length || s.ids_subcategorias.length) n += 1;
  if (s.availability) n += 1;
  if (s.search) n += 1;
  return n;
}

export function produtosFilterStateToQueryParams(state) {
  const s = normalizeProdutosFilterState(state);
  const params = {};
  if (s.ids_categorias.length) params.ids_categorias = s.ids_categorias;
  if (s.ids_subcategorias.length) params.ids_subcategorias = s.ids_subcategorias;
  if (s.availability) params.availability = s.availability;
  if (s.search) params.search = s.search;
  return params;
}

export function buildProdutosFilterSummaries(state, t) {
  const s = normalizeProdutosFilterState(state);
  const items = [];
  const tr = (key, fallback, vars) =>
    t(`dashboardPage.produtosFilters.${key}`, { defaultValue: fallback, ...vars });

  s.ids_categorias.forEach((id) => {
    const label = s.labels.categories[String(id)] || `#${id}`;
    items.push({
      key: `cat:${id}`,
      label,
      title: tr("chipCategoryTooltip", "Categoria: {{value}}", { value: label }),
      tone: "emphasis",
    });
  });

  s.ids_subcategorias.forEach((id) => {
    const label = s.labels.subcategories[String(id)] || `#${id}`;
    items.push({
      key: `sub:${id}`,
      label,
      title: tr("chipSubcategoryTooltip", "Subcategoria: {{value}}", { value: label }),
    });
  });

  if (s.availability) {
    const label =
      s.availability === "imediata"
        ? tr("availabilityImmediate", "Disponibilidade imediata")
        : tr("availabilityOrder", "Sob encomenda");
    items.push({
      key: "availability",
      label,
      title: label,
    });
  }

  if (s.search) {
    items.push({
      key: "search",
      label: tr("chipSearchShort", "Busca: {{value}}", { value: s.search }),
      title: tr("chipSearchTooltip", "Busca: {{value}}", { value: s.search }),
    });
  }

  return items;
}
